<template>
    <va-show-layout>
        <va-show :item="item">
            <v-row justify="center">
                <v-col sm="6">
                    <base-material-card>
                        <template v-slot:heading>
                            <div class="display-2">
                                {{ title }}
                            </div>
                        </template>
                        <v-card-text>
                            <va-field source="id" type="text"></va-field>
                            <va-field source="name" type="text"></va-field>
                            <va-field
                                source="countryCode"
                                type="text"
                            ></va-field>
                            <va-field
                                source="defaultCurrencyCode"
                                type="text"
                            ></va-field>
                            <va-field
                                source="defaultLanguageCode"
                                type="text"
                            ></va-field>
                            <va-field
                                source="domainName"
                                type="text"
                            ></va-field>
                            <va-field
                                source="created_at"
                                type="date"
                            ></va-field>
                            <va-field
                                source="updated_at"
                                type="date"
                            ></va-field>
                        </v-card-text>
                    </base-material-card>
                </v-col>
            </v-row>
        </va-show>
    </va-show-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
